import { ICellRendererParams } from "ag-grid-community";
import { NumericType, TimeType } from "src/shared/models/metric";
import MetricData from "src/shared/models/metric-data";
import ModuleDataGroupItem from "src/shared/models/module-data-group-item";
import { ErrorCode } from "src/app/dashboard/modules/extended-kpi/extended-kpi.model";

export interface QualityScoreRow
{
    Group: ModuleDataGroupItem;
    MetricData: MetricData;
    ColorData: ColorData;
    IsNa: boolean;
    IsActive: boolean;
    Agents?: number;
    Evaluations?: number;
    Variance?: number;
    isTeam: boolean;
}

export interface QualityScoreData {
    MetricName: string;
    NumericType: NumericType;
    RowData: Array<QualityScoreRow>;
    Error: ErrorCode;
    ScalePoints: number[];
    AvgScoreData: AvgScoreData;
    GroupGUIDs: Array<string>;
}

export interface AvgScoreData {
    Value: number;
    DisplayValue: string;
    ColorData: ColorData;
}

export interface ColorData {
    Color: string;
    Hex: string;
}

export interface QualityScoreCellRendererParams extends ICellRendererParams {
    MetricData: MetricData;
}

export interface QualityScoreRangeSetting {
    rangePoints: number[];
}

export enum ModuleView {
    Scoreboard = "scoreboard",
    Evaluations = "evaluations",
    Channels = "channels",
}

export interface ViewByDropDownOptions {
    setValue: string;
    displayName: string;
}